<template>
  <div class="business-search-box">
    <div class="top-banner-box">
      <div
        class="top-banner-img"
        :style="{ backgroundImage: `url(${headerBgUrl})` }"
      ></div>
    </div>

    <div class="container">
      <div class="new-message">
        <div class="translation-title">
          <div class="con-title-md">赋码追溯流程</div>
          <div class="translation-button" @click="onClickFuma()">我要赋码</div>
        </div>

        <div class="message-box">
          <div
            class="center-banner-img"
            :style="{ backgroundImage: `url(${advBgUrl})` }"
          ></div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="new-message">
        <div class="con-title" style="margin-bottom: 47px">认证企业</div>
        <div class="message-enterprise">
          <div class="message-box-enterprise">
            <el-card
              :body-style="{ padding: '0px' }"
              shadow="hover"
              class="message-card-enterprise"
              v-for="(item, index) in enterpriseList"
              :key="'message_' + index"
            >
              <div class="product-img">
                <img
                  :src="item.enterprisePic"
                  alt=""
                  class="product-img-1"
                  ref="image"
                />
              </div>
            </el-card>
          </div>
        </div>
        <div class="message-enterprise" style="margin-top: 21px">
          <div class="message-box-enterprise">
            <el-card
              :body-style="{ padding: '0px' }"
              shadow="hover"
              class="message-card-enterprise"
              v-for="(item, index) in enterpriseList1"
              :key="'message_' + index"
            >
              <div class="product-img">
                <img
                  :src="item.enterprisePic"
                  alt=""
                  class="product-img-1"
                  ref="image"
                />
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="new-message">
        <div class="con-title">赋码产品</div>
        <div class="message-box" style="margin-top: 20px">
          <el-card
            :body-style="{ padding: '0px' }"
            shadow="hover"
            class="message-card"
            v-for="(item, index) in productList"
            :key="'message_' + index"
          >
            <div class="product-box">
              <div class="product-img">
                <img
                  :src="item.productPicUrl"
                  alt=""
                  ref="image"
                  class="product-img-1"
                />
              </div>
              <div class="product_name">{{ item.productName }}</div>
              <div class="product_enterprise">{{ item.enterpriseName }}</div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="con-title-big">平台优势</div>
      <div class="bottom-banner">
        <div class="ys_model" v-for="(item, index) in ysList">
          <div class="ys_model_1">
            <div class="ys_image">
              <img :src="item.value" alt="" ref="image" class="" />
            </div>
            <div class="ys_name">
              {{ item.name }}
            </div>
            <div class="ys_mark">
              <p>
                {{ item.remarks }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDictionaryItem,
  getTranslationEnterpriseList,
  getTranslationProductList,
} from "../../utils/interface"
import { mapState } from "vuex"

export default {
  //   赋码追溯
  name: "saas",
  metaInfo: {
    title:
      "赋码追溯- 面向水泵及相关产业链提供备行业影响力的公共检测服务-宁夏工业企业数字化转型公共服务平台",
    meta: [
      {
        name: "keywords",
        content:
          "宁夏工业企业数字化转型公共服务平台|水泵产品检测服务|水泵智能检测系统|水泵质量检测中心水泵设备检测|水泵检测机构",
      },
      {
        name: "description",
        content:
          "宁夏工业企业数字化转型公共服务平台赋码追溯平台面向水泵及相关产业链提供具备行业影响力的公共检测服务。为水泵行业提供申请、检测、认证、赋码、追溯的完整管理体系支持服务。",
      },
    ],
  },
  components: {},
  data() {
    return {
      headerBgUrl: "",
      advBgUrl: "",
      goodUrl: "",
      enterpriseList: [],
      enterpriseList1: [],
      productList: [],
      ysList: [],
      params: {
        current: 1,
        pageSize: 10,
      },
    }
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  created() {
    if (this.$store.state.isLogin) {
    } else {
    }
    this.getOptionsData()
  },
  mounted() {
    this.showTopBox = true
    window.addEventListener("scroll", this.menu)
  },
  methods: {
    onClickLogin() {
      this.$router.push("/login")
    },
    getOptionsData() {
      getDictionaryItem({
        code: "FMZS_ADV_TOP",
      }).then((res) => {
        if (res != null && res.length > 0) {
          this.headerBgUrl = res[0].value
        }
      })

      getDictionaryItem({
        code: "FMZS_LCT",
      }).then((res) => {
        if (res != null && res.length > 0) {
          this.advBgUrl = res[0].value
        }
      })

      getDictionaryItem({
        groupCode: "FMZS_YST",
      }).then((res) => {
        if (res != null && res.length > 0) {
          this.ysList = res
        }
      })

      getTranslationEnterpriseList({
        current: 1,
        pageSize: 5,
        status: "REVIEW_PASS",
      }).then((res) => {
        if (res) {
          this.enterpriseList = res.list
          if (res.total > 5) {
            getTranslationEnterpriseList({
              current: 2,
              pageSize: 5,
              status: "REVIEW_PASS",
            }).then((res1) => {
              if (res1) {
                this.enterpriseList1 = res1.list
              }
            })
          }
        }
      })

      getTranslationProductList({
        current: 1,
        pageSize: 10,
        status: "REVIEW_PASS",
      }).then((res) => {
        if (res) {
          this.productList = res.list
        }
      })
    },
    onClickFuma() {
      let newToken = this.$cookies.get("api_token_new")
      if (newToken) {
        this.$router.push("/codeTraceabilityOther")
      } else {
        this.$router.push("/login")
      }
    },
  },
}
</script>

<style scoped lang="less">
.business-search-box {
  .el-card {
    background-color: #fff0;
    border-radius: 4px;
    border: 0px solid #ebeef5;
    overflow: hidden;
    color: #303133;
    -webkit-transition: 0.3s;
    -o-transition: 0.3s;
    transition: 0.3s;
    margin: 9px 10px;
  }

  background-color: #f6f6f8;

  .center-banner-img {
    height: 786px;
    width: 100%;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .top-banner-img {
    height: 473px;
    width: 100%;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .top-banner-center {
      height: 350px;
      width: 715px;
    }

    .title {
      height: 100px;
      font-size: 40px;
      font-weight: 800;
      color: #f7f7f7;
      text-align: center;
      letter-spacing: 5px;
    }
  }

  .new-message {
    .message-box {
      display: flex;
      flex-wrap: wrap;
      margin-top: 40px;
    }

    .message-enterprise {
      margin: 0px auto;
      background-image: url("../../assets/image/fmzs-b.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }

    .message-box-enterprise {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin: 0px 20px;

      .product-img {
        width: 100%;
        height: 150px;
        background-image: url("../../assets/image/fmzs-e.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .product-img-1 {
          margin: auto;
          max-width: 120px;
        }
      }
    }

    .product-box {
      background-color: #fff;

      .product-img {
        width: 100%;
        height: 150px;

        .product-img-1 {
          width: 100%;
          height: 100%;
        }
      }
    }

    .message-card-enterprise {
      width: calc(20% - 20px);
      position: relative;
      overflow: visible;
      transition: all 0.2s;
    }

    .message-card {
      width: calc(20% - 20px);
      margin-bottom: 20px;
      position: relative;
      overflow: visible;
      transition: all 0.2s;
    }

    .card-top-box {
      display: flex;
      justify-content: space-between;
      padding: 0 0 30px 0;
      margin: 0 36px;
      border-bottom: 1px dotted rgba(51, 51, 51, 0.2);
    }

    .card-top-left {
      color: #333333;
    }

    .card-top-left-title {
      font-size: 24px;
      font-weight: bold;
    }

    .card-top-left-num {
      background: rgba(51, 51, 51, 0.2);
      margin-top: 5px;
      border-radius: 12px;
      font-size: 14px;
    }

    .card-top-right {
      background: url("../../assets/businessSearch02.png") no-repeat;
      background-size: 100% 100%;
      width: 105px;
      height: 82px;
      text-align: center;
      position: absolute;
      top: -8px;
      right: 30px;
      color: #009898;
    }

    .card-top-right-num {
      font-size: 29px;
      font-weight: bold;
      margin-top: 7px;
    }

    .card-top-right-title {
      font-size: 14px;
    }

    .message-card:hover {
      .card-top-right {
        background: url("../../assets/businessSearch01.png") no-repeat;
      }

      .card-top-right {
        color: #ffffff;
      }
    }

    .card-box {
      height: 260px;
      padding: 20px 36px;
      position: relative;
    }

    .card-list {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      cursor: pointer;
    }

    .list-title {
      width: 55%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .list-title:hover {
      color: #009999;
    }

    .list-date {
      width: 35%;
      text-align: right;
    }

    .card-more {
      position: absolute;
      right: 36px;
      bottom: 20px;
      height: 14px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.7);
      cursor: pointer;
      user-select: none;
    }

    .card-more:hover {
      color: #009999;
    }
  }

  .big-box {
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding-bottom: 52px;
    padding-top: 5px;

    .big-info {
      .info-box {
        margin-top: 30px;
      }

      .info-card {
        border-bottom: 1px solid gray;
        margin-bottom: 30px;
      }

      .info-item {
        display: flex;
        justify-content: space-between;
      }

      .item-left {
        cursor: pointer;
        width: 70%;
      }

      .left-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        cursor: pointer;
      }

      .left-bottom {
        display: flex;
      }

      .item-right {
        width: 20%;
        text-align: right;
      }

      .star-icon {
        color: #c2c2c2;
        cursor: pointer;
        font-size: 24px;
      }

      .star-select {
        color: #f7ba2a;
      }

      .star-normal {
        color: #c2c2c2;
      }

      .bottom-01 {
        width: 103px;
        height: 24px;
        line-height: 24px;
        background: #dcdcdc;
        font-size: 14px;
        color: #333333;
        text-align: center;
        margin-right: 10px;
      }

      .bottom-02 {
        width: 103px;
        height: 24px;
        line-height: 24px;
        background: #f4cdcd;
        font-size: 14px;
        color: #fe260f;
        text-align: center;
      }

      .right-date {
        font-size: 14px;
        color: #333333;
      }

      .info-more {
        text-align: center;
        font-size: 14px;
        color: #000000;
        cursor: pointer;
        user-select: none;
      }

      .info-more:hover {
        color: #009999;
      }

      /deep/ .el-card__body {
        padding: 40px 75px 20px 75px;
        background-color: transparent !important;
      }
    }
  }

  .bottom-banner-img {
    height: 239px;
    width: 100%;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: 100%;
    cursor: pointer;
  }

  .container {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 10px;
  }

  .container-big {
    width: 100%;
    margin: 0 auto;
    margin-bottom: 10px;
  }

  .con-title-big {
    font-size: 29px;
    font-weight: bold;
    color: #333333;
    text-align: center;
    padding-top: 30px;
    padding-bottom: 30px;
    background-color: #fff;
  }

  .con-title {
    font-size: 29px;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-top: 30px;
  }

  .con-title-md {
    width: 90%;
    font-size: 29px;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-top: 30px;
  }

  .title-tag {
    background-color: #d81e06;
    color: white;
    border-radius: 3px;
    font-size: 12px;
    font-weight: bold;
    padding: 3px 6px;
    height: 100%;
    transform: scale(0.8);
  }

  .content {
    /deep/ .el-col-4 {
      width: 20%;
    }
  }

  /deep/ .el-card.is-hover-shadow:focus,
  .el-card.is-hover-shadow:hover {
    -webkit-box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0.1) !important;
    box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0.1) !important;
  }

  .translation-title {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
  }

  .translation-button {
    text-align: center;
    margin-top: 40px;
    width: 91px;
    height: 29px;
    line-height: 29px;
    border: 1px solid #3979fb;
    border-radius: 10px;
    cursor: pointer;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0153fe;
  }

  .product_name {
    margin-top: 7px;
    font-size: 14px;
    text-align: center;
  }

  .product_enterprise {
    margin-top: 3px;
    font-size: 12px;
    text-align: center;
    padding-bottom: 15px;
  }

  .bottom-banner {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
  }
  .ys_model {
    width: 25%;
    margin: 5px 10px;
  }
  .ys_model_1 {
    margin: 5px auto;
  }

  .ys_image img {
    width: 55px;
    height: 55px;
    margin: 0px 112.5px;
  }

  .ys_name {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    margin: 10px;
  }
  .ys_mark {
    height: 100px;
    margin: 0px 20px;
  }

  .ys_mark p {
    text-align: left;
    font-size: 14px;
    height: 25px;
    line-height: 25px;
  }
}
</style>
<style lang="less"></style>



// WEBPACK FOOTER //
// src/components/reversoContext/index.vue